import React from "react";
import {
  Brand,
  Content,
  ContentVariants,
  Flex,
  FlexItem
} from "@patternfly/react-core";

import useAppearance from "shared/appearance/hooks/useAppearance";
import { brand } from "../../../config/brand";
import SchoolHeaderSocials from "../../header/top/SchoolHeaderSocials/SchoolHeaderSocials";
import { useBreakpoint } from "shared/hooks/useBreakpoint";

import "./SchoolFooterBrand.css";

const SchoolFooterBrand = () => {
  const { isMobile } = useBreakpoint();
  const {
      colorScheme
  } = useAppearance();

  const logo =
    colorScheme === "dark"
      ? brand.logo.dark
      : brand.logo.light;
  
  return (
    <Flex
      alignItems={{ default: "alignItemsCenter" }}
      className="school-footer-brand"
    >
      {!isMobile && (
        <FlexItem flex={{ default: "flex_1" }} />
      )}

      <FlexItem flex={{ default: "flex_1" }}>
        <Flex
          justifyContent={{
            default: isMobile
              ? "justifyContentFlexStart"
              : "justifyContentCenter",
          }}
          alignItems={{ default: "alignItemsCenter" }}
          spaceItems={{ default: "spaceItemsMd" }}
        >
          <FlexItem>
            <Brand
              src={logo}
              alt={brand.lines.join(" ")}
            />
          </FlexItem>

          {!isMobile && (
            <FlexItem>
              <Content component={ContentVariants.strong}>
                {brand.lines.map((line, index) => (
                  <React.Fragment key={line}>
                    {line}
                    {index < brand.lines.length - 1 && <br />}
                  </React.Fragment>
                ))}
              </Content>
            </FlexItem>
          )}
        </Flex>
      </FlexItem>

      <FlexItem flex={{ default: "flex_1" }}>
        <Flex justifyContent={{ default: "justifyContentFlexEnd" }}>
          <SchoolHeaderSocials forceColorScheme="dark" />
        </Flex>
      </FlexItem>
    </Flex>
  );
};

export default SchoolFooterBrand;